import { Link } from "@tanstack/react-router";
import { ChevronsUpDown } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export function TopNav() {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white flex items-center justify-between min-h-[3rem] px-4 py-4 z-1000">
      <div className="flex items-center gap-0.5">
        <Link to="/innovation-days-demo">
          <p className="text-[20px] font-medium text-black">Essence.</p>
        </Link>
      </div>
      <div className="flex items-center gap-2 px-2 py-1 rounded-xl">
        <Avatar className="w-8 h-8 shrink-0">
          <AvatarFallback className="bg-secondary-100 text-secondary-700 text-xs">
            U
          </AvatarFallback>
        </Avatar>
        <p className="text-xs text-secondary-600 leading-none overflow-ellipsis overflow-hidden">
          user@example.com
        </p>
        <ChevronsUpDown className="w-4 h-4 text-secondary-600" />
      </div>
    </div>
  );
}
